exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".judge .social svg[data-v-3c19f324]{font-size:24px}.hover-judge[data-v-3c19f324]{position:relative;overflow:hidden;border-radius:50px;border:4px solid rgb(0 0 0/15%)}.info-judge[data-v-3c19f324]{position:absolute;color:#000;left:0;padding:20px;bottom:-40px;height:0;background:rgb(255 255 255/70%);backdrop-filter:blur(10px);border-top:none;transition:height .25s ease-in-out}.hover-judge:hover .info-judge[data-v-3c19f324]{height:290px;transition:height .25s ease-in}.hover-judge:hover .info-judge.long[data-v-3c19f324]{height:338px}.VueCarousel-dot-container button[data-v-3c19f324]{margin-top:0}.VueCarousel-dot-container .VueCarousel-dot--active[data-v-3c19f324]{background-color:#e91e63!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c19f324","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Judges.vue
// module id = 115
// module chunks = 0